// extracted by mini-css-extract-plugin
export default {"list":"aside-profile_list__53H9I","active":"aside-profile_active__g8B1K"};